window.DOLOBITES_BOOKING_CONFIG = {
  currency: "USD",
  depositPercentage: 50,

  baseLocation: {
    address: "36 Cos Cob Avenue, Cos Cob, CT 06807, USA"
  },

  packages: [
    {
      id: "classic",
      name: "Classic Experience",
      maxGuests: 44,
      flavoursIncluded: 2,
      serviceHoursIncluded: 2,
      price: 549
    },
    {
      id: "celebration",
      name: "Celebration Experience",
      maxGuests: 88,
      flavoursIncluded: 4,
      serviceHoursIncluded: 2,
      price: 879
    },
    {
      id: "signature",
      name: "Signature Experience",
      maxGuests: 132,
      flavoursIncluded: 6,
      serviceHoursIncluded: 2,
      price: 1129
    }
  ],

  customQuoteFromGuests: 133,
flavours: [
  {
    id: "lemon",
    name: "Lemon",
    extraPrice: 0
  },
  {
    id: "mango",
    name: "Mango",
    extraPrice: 40
  },
  {
    id: "strawberry",
    name: "Strawberry",
    extraPrice: 0
  },
  {
    id: "passion-fruit",
    name: "Passion Fruit",
    extraPrice: 0
  },
  {
    id: "vanilla",
    name: "Vanilla",
    extraPrice: 0
  },
  {
    id: "dark-chocolate",
    name: "Dark Chocolate",
    extraPrice: 40
  },
  {
    id: "chocolate",
    name: "Chocolate",
    extraPrice: 0
  },
  {
    id: "coffee",
    name: "Coffee",
    extraPrice: 0
  },
  {
    id: "pistachio",
    name: "Pistachio",
    extraPrice: 40
  },
  {
    id: "hazelnut",
    name: "Hazelnut",
    extraPrice: 20
  },
  {
    id: "cheesecake",
    name: "Cheesecake",
    extraPrice: 0
  },
  {
    id: "bacio",
    name: "Bacio",
    extraPrice: 0
  },
  {
    id: "tiramisu",
    name: "Tiramisù",
    extraPrice: 0
  },
  {
    id: "stracciatella",
    name: "Stracciatella",
    extraPrice: 0
  },
  {
    id: "mint-chocolate",
    name: "Mint Chocolate",
    extraPrice: 0
  },
  {
    id: "amarena-cookies",
    name: "Amarena Cookies",
    extraPrice: 0
  },
  {
    id: "oreo",
    name: "Oreo",
    extraPrice: 0
  },
  {
    id: "coconut",
    name: "Coconut",
    extraPrice: 0
  },
  {
    id: "cremino",
    name: "Cremino",
    extraPrice: 0
  }
],  extras: [
    {
      id: "extra-service-hour",
      name: "Extra service hour",
      description: "Add one additional hour of live gelato service.",
      pricingType: "fixed",
      price: 120
    },
    {
      id: "premium-sprinkles",
      name: "Premium sprinkles",
      description: "A selection of premium sprinkles for your guests.",
      pricingType: "fixed",
      price: 25
    },
    {
      id: "special-toppings",
      name: "Special toppings",
      description: "Add a selection of special toppings to the experience.",
      pricingType: "fixed",
      price: 35
    },
    {
      id: "waffle-cones",
      name: "Waffle cones",
      description: "Waffle cones available for every guest.",
      pricingType: "perGuest",
      price: 1
    }
  ],
  travelBands: [
    {
      minMiles: 0,
      maxMiles: 15,
      fee: 0
    },
    {
      minMiles: 15,
      maxMiles: 20,
      fee: 15
    },
    {
      minMiles: 20,
      maxMiles: 30,
      fee: 25
    },
    {
      minMiles: 30,
      maxMiles: 40,
      fee: 60
    }
  ],

  maximumServiceDistanceMiles: 40,

  
};